import React, { useCallback, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate, useSearchParams, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HeaderBar from "./components/HeaderBar";
import GamePage from "./pages/GamePage";
import DemoLauncher from "./pages/DemoLauncher";
import AdminPage from "./pages/AdminPage";
import ApiClient from "./lib/api";
import "./App.css";

function Shell() {
  const [config, setConfig] = useState(null);
  const [health, setHealth] = useState(null);

  const refreshConfig = useCallback(async () => {
    try {
      setConfig(await ApiClient.getConfig());
    } catch (e) {
      console.warn("config load failed", e);
    }
  }, []);

  const refreshHealth = useCallback(async () => {
    try {
      setHealth(await ApiClient.corebridgeHealth());
    } catch (e) {
      setHealth({ ok: false });
    }
  }, []);

  useEffect(() => {
    refreshConfig();
    refreshHealth();
    const t = setInterval(refreshHealth, 30_000);
    return () => clearInterval(t);
  }, [refreshConfig, refreshHealth]);

  return (
    <>
      <HeaderBar config={config} health={health} />
      <main>
        <Routes>
          <Route path="/" element={<Root config={config} />} />
          <Route path="/launch" element={<DemoLauncher config={config} refreshConfig={refreshConfig} />} />
          <Route path="/admin" element={<AdminPage config={config} refreshConfig={refreshConfig} />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      <footer className="border-t border-[var(--kk-line)] mt-12 py-6 text-center">
        <div className="text-[10px] uppercase tracking-[0.3em] text-[var(--kk-muted)] font-mono">
          {config?.provider_name} · {config?.provider_id} · Game {config?.game_id}
        </div>
      </footer>
    </>
  );
}

function Root({ config }) {
  // If there's a launch_token in URL, render the game. Else send to demo launcher.
  const [params] = useSearchParams();
  const token = params.get("launch_token");
  if (!token) return <Navigate to="/launch" replace />;
  return <GamePage config={config} />;
}

export default function App() {
  return (
    <BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "var(--kk-graphite)",
            border: "1px solid var(--kk-line)",
            color: "var(--kk-ivory)",
            fontFamily: "Inter, system-ui",
          },
        }}
      />
      <Shell />
    </BrowserRouter>
  );
}
